/**
 * Single source for env (REACT_APP_*). Aligns with system/env_config.py naming.
 * No VITE_* or fallbacks; CRA only embeds REACT_APP_*.
 */
function getEnv(key: string): string {
  const v = process.env[key];
  return typeof v === 'string' ? v.trim() : '';
}

export const config = {
  apiBase: getEnv('REACT_APP_API_BASE'),
  apiBaseRoot: getEnv('REACT_APP_API_BASE_ROOT'),
  /** Where the console reads its data: 'renglo' (the API, default) or 'fixture' (invented records, no API). */
  dataSource: getEnv('REACT_APP_DATA_SOURCE'),
  portfolio: getEnv('REACT_APP_PORTFOLIO'),
  /**
   * @deprecated Org is selected at runtime from GET /_auth/tree (workspace store).
   * Kept only as optional first-run fallback if nothing is in localStorage.
   */
  org: getEnv('REACT_APP_ORG'),
  /** WebSocket URL for agent real-time chat (e.g. wss://api.example.com/ws). */
  websocketUrl: getEnv('REACT_APP_WEBSOCKET_URL'),
  /**
   * Scheduler extension URL key. Local env_config uses `arbitiumlab`;
   * production platform_env uses `arbitium`. Override with REACT_APP_ARBITIUM_EXTENSION.
   */
  arbitiumExtension: getEnv('REACT_APP_ARBITIUM_EXTENSION') || 'arbitium',
  cognito: {
    region: getEnv('REACT_APP_COGNITO_REGION') || 'us-east-1',
    userPoolId: getEnv('REACT_APP_COGNITO_USER_POOL_ID'),
    appClientId: getEnv('REACT_APP_COGNITO_APP_CLIENT_ID'),
    domain: getEnv('REACT_APP_COGNITO_DOMAIN') || 'arbitium-auth.auth.us-east-1.amazoncognito.com',
    oauthRedirectUrl: getEnv('REACT_APP_OAUTH_REDIRECT_URL'),
  },
} as const;
